import React from 'react';
import { Form } from 'react-bootstrap';
import { isTempSavedValue, isTempSavedValueWithoutAgency } from './utils';
import { TempSavedValue } from '../types';

interface RestoreFormProps {
  onChange: (jsonObject: TempSavedValue) => void;
}

/**
 * 復元ボタンコンポーネントです。
 * @param {function} props.onClick - ボタンクリック時に呼ばれるコールバック関数
 * @returns {JSX.Element} - 復元ボタンのJSX要素
 */
const RestoreForm: React.FC<RestoreFormProps> = ({ onChange }) => {

  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];
    const confirm: boolean = window.confirm('一次保存データを取り込みますか？');
    if(file !== null && confirm === true) {
      const reader = new FileReader();
      reader.onload = (event) => {
        try {
          const uploadedFileContents = JSON.parse(event.target?.result as string);
          if(isTempSavedValue(uploadedFileContents)) {
            onChange(uploadedFileContents);
          } else {
            if(isTempSavedValueWithoutAgency(uploadedFileContents)) {
              // 1.0版の代理人情報がない一次保存ファイルに対応するための処理
              uploadedFileContents['代理人'] = {
                '識別番号': '',
                '住所又は居所': '',
                '氏名又は名称': '',
                '代表者': '',
                '電話番号': ''
              };
              console.log(uploadedFileContents);
              onChange(uploadedFileContents);
            } else {
              window.alert('アップロードされたファイルの形式が誤っています。');
            }
          }
        } catch(e) {
          window.alert('アップロードされたファイルの形式が誤っています。');
          return false
        }
      };
      reader.readAsText(file);
    }
    event.target.value = '';
  };

  return (
    <Form.Group
      onChange={handleFileInputChange}
    >
      <Form.Control type="file" accept=".json" />
    </Form.Group>
  );
};

export default RestoreForm;
